import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type KPISet, type KPIStatistics } from 'types/models';

export interface KPISetState extends EntityState<KPISet>, ActiveState {
   activeNode?: {
      type: string;
      id: number;
   };
   statistics: KPIStatistics | null;
}

const store = createEntityStore<KPISetState>(
   { activeNode: undefined, statistics: { general: {}, organisations: [], tags: [] } },
   { resettable: true, name: 'kpiSet' }
);

export default store;
